import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import scrollbars from '@helpers/scrollbars';
import svgIcon from '@img/misc/breadcrumb-separator.svg';
import styled from 'styled-components';
const Container = styled.nav `
  @media print {
    display: none;
  }

  &[data-theme='dark'],
  &[data-theme='transparent'] {
    --fgColor: ${brand.white};
  }

  &[data-theme='light'] {
    --bgColor: ${brand.white};
    --fgColor: ${brand.black};
  }

  &[data-theme='dark'] {
    --bgColor: ${brand.black};
  }

  &[data-theme='transparent'] {
    --bgColor: transparent;
  }

  color: var(--fgColor);
  min-width: 0;
`;
const List = styled.ul `
  ${scrollbars};

  display: flex;
  align-items: center;
  overflow-x: auto;
  padding-bottom: 2px;
  white-space: nowrap;
`;
const Item = styled.li `
  ${fonts.apercu.light};

  display: inline-flex;
  align-items: center;
  font-size: 16px;
  line-height: 1.4em;
  margin-right: 8px;

  &:not(:last-child)::after {
    content: '';
    display: inline-block;
    background: url(${svgIcon}) no-repeat center;
    height: 11px;
    margin-left: 8px;
    width: 9px;

    [data-theme='light'] & {
      /* Results in a match to brand.black (#282828) */
      filter: invert(0.905);
    }
  }
`;
const ItemLink = styled.a `
  ${transition('text-decoration-color')};

  display: inline-block;
  color: currentColor;
  text-decoration: underline;
  text-underline-position: under;
  text-decoration-color: var(--bgColor);

  &[aria-current='location'],
  &:hover {
    text-decoration: underline;
    text-decoration-color: var(--fgColor);
  }
`;
const BreadcrumbStyles = {
    Container,
    List,
    Item,
    ItemLink,
};
export default BreadcrumbStyles;
